<template>
    <div>
        <table class="table table-borderless">
            <tbody>
            <tr>
                <td class="py-0">
                    <I name="empty" class="h1 mr-4 cSecondary" />
                </td>
                <td class="w-25 px-1 py-0">
                    <p class="name text-secondary text-black-50 mt-4 mb-1">DOKUMENTMALL</p>
                </td>
                <td class="py-0"></td>
                <td class="w-75 px-1 py-0">
                    <p class="name text-secondary text-black-50 mt-4 mb-1">OM MALLEN</p>
                </td>
            </tr>
            <tr>
                <td>
                    <I name="calendar-31" class="h1 mr-4 cSecondary"/>
                </td>
                <td class="w-25 p-1 pt-3">
                    <p class="title">Årsavslutsmöte</p>
                </td>
                <td/>
                <td class="w-75 p-1 pt-3">
                    <p class="value">Årsavslutsmötet är främst tänkt att användas av Revision i samband med att revisionsarbetet avslutas (för Ekonomiservice rekommenderas det snarlika dokumentet Bokslutsmöte). Som underlag används en importerad SIE-fil som följer BAS-kontoplanen.</p>
                    <p class="value">Det är viktigt att kontrollera presentationen innan den visas för kunden. Dokumentet skall således inte göras tillsammans med kunden utan det skall ha färdigställts innan mötet och endast visas för kunden i presentationsläget.</p>
                    <b-collapse id="collapse-info" class="mt-2">
                        <p class="value">Presentationen innehåller följande sektioner:</p>
                        <p class="value">
                        <ul>
                            <li>Noteringar från bokslutsarbetet (valfri)</li>
                            <li>Utfall och analys av året</li>
                            <li>Din resa eller Framtidsplaner (valfri)</li>
                            <li>Signering</li>
                            <li>Övrigt (valfri)</li>
                            <li>Feedback</li>
                            <li>Nästa möte</li>
                        </ul>
                        <p class="value">Även om det går fort att skapa presentationen är det viktigt att reflektera över innehållet. Lämplig tid att lägga på skapandet och kontroll av dokumentet kan vara 30-60 minuter.</p>
                        <p class="value">Kontakta Monika Lindberg för idéer eller frågor rörande dokumentet.</p>
                    </b-collapse>
                    <b-button v-b-toggle.collapse-info variant="outline-primary">
                        <span class="when-opened">Mindre information</span>
                        <span class="when-closed">Mer information</span>
                    </b-button>
                </td>
            </tr>
            <tr>
                <td colspan="4"><hr/></td>
            </tr>
            <tr>
                <td>
                    <I name="aim" class="h1 mr-4 cSecondary"/>                    
                </td>
                <td class="w-25 p-1 pt-3">                    
                    <span class="heading">1. Välj bolag:</span>
                </td>
                <td></td>
                <td class="w-75 p-1 pb-4 pt-3">
                    <CompanySelection
                        :locked="editing"
                        :disabled="editing"
                        :disabledSource="editing"
                        :company="company"
                        :useLatest="false"
                        @company="selectedCompany = $event"
                        @source="selectedSource = $event"
                        @branch="selectedBranch = $event" />
                </td>
            </tr>
            <tr>
                <td>
                    <I name="flag2" class="h1 mr-4 cSecondary"/>
                </td>
                <td class="w-25 p-1 pt-3">
                    <div class="heading">2. Noteringar:</div>
                    <div>Ta upp de viktigaste noteringar som gjorts under revisionsarbetet.</div>
                    <div>Extra viktiga frågor kan stjärnmarkeras.</div>
                    <div>Tomma rader syns inte i presentationen.</div>
                </td>
                <td class="p-2 pt-3">
                    <div><a @click="check01 = !check01"><I name="star" class="h2" :class="{cLightGrey: !check01, cSecondary: check01}"/></a></div>
                    <div class="star"><a @click="check02 = !check02"><I name="star" class="h2" :class="{cLightGrey: !check02, cSecondary: check02}"/></a></div>
                    <div class="star"><a @click="check03 = !check03"><I name="star" class="h2" :class="{cLightGrey: !check03, cSecondary: check03}"/></a></div>
                    <div class="star"><a @click="check04 = !check04"><I name="star" class="h2" :class="{cLightGrey: !check04, cSecondary: check04}"/></a></div>
                    <div class="star"><a @click="check05 = !check05"><I name="star" class="h2" :class="{cLightGrey: !check05, cSecondary: check05}"/></a></div>
                </td>
                <td class="w-75 p-1 pt-3 pb-5">
                    <div><b-form-input v-model="text01" class="value w-25" placeholder="Ex. Attesteringsrutiner"></b-form-input></div>
                    <div class="mt-0"><b-form-input v-model="text02" class="value mt-2 w-25" placeholder="Ex. Intäktsrutin"></b-form-input></div>
                    <div class="mt-0"><b-form-input v-model="text03" class="value mt-2 w-25" placeholder="Ex. Kundfordringar"></b-form-input></div>
                    <div class="mt-0"><b-form-input v-model="text04" class="value mt-2 w-25" placeholder=""></b-form-input></div>
                    <div class="mt-0"><b-form-input v-model="text05" class="value mt-2 w-25" placeholder=""></b-form-input></div>
                </td>
            </tr>
            <tr>
                <td>
                    <I name="bubble-pencil" class="h1 mr-4 cSecondary"/>
                </td>
                <td class="w-25 p-1 pt-3">
                    <span class="heading">3. Analys:</span>
                </td>
                <td class="p-2 pt-3"><b-form-checkbox switch size="lg" v-model="inlcudeCompass"></b-form-checkbox></td>
                <td class="w-75 p-1 pb-4 pt-3">
                    <div class="py-1 h5">Inkludera bolagskompass</div>
                    <div class="name text-secondary text-black-50 mb-1" style="opacity: 0.70;">KOMMENTAR</div>
                    <textarea :disabled="!selectedCompany || selected !== 'custom'" v-model="comment" class="value w-100" style="height:200px;"></textarea>
                    <b-form-group :disabled="!selectedCompany">
                        <b-form-radio-group
                                v-model="selected"
                                :options="options"
                                @change="selectedChanged"
                                size="lg"
                                switches>
                        </b-form-radio-group>
                    </b-form-group>
                </td>
            </tr>

            <tr>
                <td>
                    <I name="first-aid" class="h1 mr-4 cSecondary"/>
                </td>
                <td class="w-25 p-1 pt-3">
                    <div class="heading">4. Covid-19:</div>
                    <div>Används till att ta upp frågor som har aktualiserats<br/> till följd av Coronakrisen.</div>
                    <div>Extra viktiga frågor kan stjärnmarkeras.</div>
                    <div>Tomma rader syns inte i presentationen.</div>
                </td>
                <td class="p-2 pt-3">
                    <div><a @click="check16 = !check16"><I name="star" class="h2" :class="{cLightGrey: !check16, cSecondary: check16}"/></a></div>
                    <div class="star"><a @click="check17 = !check17"><I name="star" class="h2" :class="{cLightGrey: !check17, cSecondary: check17}"/></a></div>
                    <div class="star"><a @click="check18 = !check18"><I name="star" class="h2" :class="{cLightGrey: !check18, cSecondary: check18}"/></a></div>
                    <div class="star"><a @click="check19 = !check19"><I name="star" class="h2" :class="{cLightGrey: !check19, cSecondary: check19}"/></a></div>
                    <div class="star"><a @click="check20 = !check20"><I name="star" class="h2" :class="{cLightGrey: !check20, cSecondary: check20}"/></a></div>
                </td>
                <td class="w-75 p-1 pt-3 pb-5">
                    <b-form-input v-model="text16" class="value w-25" placeholder="Ex. Revidera budgeten"></b-form-input>
                    <b-form-input v-model="text17" class="value mt-2 w-25" placeholder="Ex. Likviditetsprognos"></b-form-input>
                    <b-form-input v-model="text18" class="value mt-2 w-25" placeholder="Ex. Upprätta åtgärdslista"></b-form-input>
                    <b-form-input v-model="text19" class="value mt-2 w-25" placeholder="Ex. Se över kravrutiner"></b-form-input>
                    <b-form-input v-model="text20" class="value mt-2 w-25" placeholder="Ex. Skapa redundans"></b-form-input>
                </td>
            </tr>

            <tr>
                <td>
                    <I name="rocket" class="h1 mr-4 cSecondary"/>
                </td>
                <td class="w-25 p-1 pt-3">
                    <span class="heading">5. Din resa:</span>
                </td>
                <td class="p-2 pt-3"><b-form-checkbox switch size="lg" v-model="includeYourTrip"></b-form-checkbox></td>
                <td class="w-75 p-1 pb-4 pt-3">
                    <div class="py-1 h5">Din resa</div>
                </td>
            </tr>
            <tr v-if="!includeYourTrip">
                <td>
                    <I name="binoculars2" class="h1 mr-4 cSecondary"/>
                </td>
                <td class="w-25 p-1 pt-3">
                    <div class="heading">5. Framtidsplaner:</div>
                    <div>Ta upp saker som påverkar bolagets framtid.</div>
                    <div>Extra viktiga frågor kan stjärnmarkeras.</div>
                    <div>Tomma rader syns inte i presentationen.</div>
                </td>
                <td class="p-2 pt-3">
                    <div><a @click="check06 = !check06"><I name="star" class="h2" :class="{cLightGrey: !check06, cSecondary: check06}"/></a></div>
                    <div class="star"><a @click="check07 = !check07"><I name="star" class="h2" :class="{cLightGrey: !check07, cSecondary: check07}"/></a></div>
                    <div class="star"><a @click="check08 = !check08"><I name="star" class="h2" :class="{cLightGrey: !check08, cSecondary: check08}"/></a></div>
                    <div class="star"><a @click="check09 = !check09"><I name="star" class="h2" :class="{cLightGrey: !check09, cSecondary: check09}"/></a></div>
                    <div class="star"><a @click="check10 = !check10"><I name="star" class="h2" :class="{cLightGrey: !check10, cSecondary: check10}"/></a></div>
                </td>
                <td class="w-75 p-1 pt-3 pb-5">
                    <div><b-form-input v-model="text06" class="value w-25" placeholder="Ex. Exitplaner"></b-form-input></div>
                    <div class="mt-0"><b-form-input v-model="text07" class="value mt-2 w-25" placeholder="Ex. Hållbarhet"></b-form-input></div>
                    <div class="mt-0"><b-form-input v-model="text08" class="value mt-2 w-25" placeholder="Ex. Globalisering"></b-form-input></div>
                    <div class="mt-0"><b-form-input v-model="text09" class="value mt-2 w-25" placeholder=""></b-form-input></div>
                    <div class="mt-0"><b-form-input v-model="text10" class="value mt-2 w-25" placeholder=""></b-form-input></div>
                </td>
            </tr>


            <tr>
                <td>
                    <I name="road-sign" class="h1 mr-4 cSecondary"/>
                </td>
                <td class="w-25 p-1 pt-3">
                    <div class="heading">{{includeYourTrip ? 6 : 7}}. Övrigt:</div>
                    <div>Används till att ta upp övriga viktiga frågor, gärna sådant som leder till merförsäljning av tjänster.</div>
                    <div>Extra viktiga frågor kan stjärnmarkeras.</div>
                    <div>Tomma rader syns inte i presentationen.</div>
                </td>
                <td class="p-2 pt-3">
                    <div><a @click="check11 = !check11"><I name="star" class="h2" :class="{cLightGrey: !check11, cSecondary: check11}"/></a></div>
                    <div class="star"><a @click="check12 = !check12"><I name="star" class="h2" :class="{cLightGrey: !check12, cSecondary: check12}"/></a></div>
                    <div class="star"><a @click="check13 = !check13"><I name="star" class="h2" :class="{cLightGrey: !check13, cSecondary: check13}"/></a></div>
                    <div class="star"><a @click="check14 = !check14"><I name="star" class="h2" :class="{cLightGrey: !check14, cSecondary: check14}"/></a></div>
                    <div class="star"><a @click="check15 = !check15"><I name="star" class="h2" :class="{cLightGrey: !check15, cSecondary: check15}"/></a></div>
                </td>
                <td class="w-75 p-1 pt-3 pb-5">
                    <b-form-input v-model="text11" class="value w-25" placeholder="Ex. Konkurrentjämförelse"></b-form-input>
                    <b-form-input v-model="text12" class="value mt-2 w-25" placeholder="Ex. Hållbarhet"></b-form-input>
                    <b-form-input v-model="text13" class="value mt-2 w-25" placeholder="Ex. Värdering"></b-form-input>
                    <b-form-input v-model="text14" class="value mt-2 w-25" placeholder=""></b-form-input>
                    <b-form-input v-model="text15" class="value mt-2 w-25" placeholder=""></b-form-input>
                </td>
            </tr>
            </tbody>
        </table>

        <hr class="mt-4"/>

        <table class="mt-4 table table-borderless">
            <tbody>
            <tr>
                <td width="240px" class="p-0 pt-2">
                    <div @click="$emit('prev')" class="btn btn-outline-danger btn-block btn-lg cursor-pointer">
                        <template v-if="!editing">RADERA UTKAST</template>
                        <template v-else>AVBRYT ÄNDRINGAR</template>
                    </div>
                </td>
                <td class="h3 text-center">&nbsp;</td>
                <td width="240px" class="p-0 pt-2">
                    <div @click="create()" class="btn btn-outline-primary btn-block btn-lg cursor-pointer" :class="{disabled: !canCreate()}">
                        <template v-if="!editing">SKAPA DOKUMENT</template>
                        <template v-else>UPPDATERA DOKUMENT</template>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    /* tslint:disable */

    import ValueGroup from '@/views/ValueGroup.vue'
    import ValueSelection from '@/views/ValueSelection';
    import CompanySelection from '@/components/CompanySelection';
    import user from '@/store/modules/user';
    import * as api from '@/store/api';

    export default {
        name: "CreateDocumentYearEndMeeting",
        components: {ValueSelection, ValueGroup, CompanySelection},
        props: {
            doc: Object,
        },
        data () {
            return {
                selectedCompany: undefined,
                selectedSource: undefined,
                selectedBranch: undefined,
                ranking: undefined,
                comment: '',
                selected: 'auto',
                options: [
                    {text: 'Automatisk kommentar', value: 'auto'},
                    {text: 'Egen kommentar', value: 'custom'},
                    {text: 'Ingen kommentar', value: 'no'},
                ],
                sni: undefined,
                text01: '',
                text02: '',
                text03: '',
                text04: '',
                text05: '',
                text06: '',
                text07: '',
                text08: '',
                text09: '',
                text10: '',
                text11: '',
                text12: '',
                text13: '',
                text14: '',
                text15: '',
                text16: '',
                text17: '',
                text18: '',
                text19: '',
                text20: '',
                inlcudeCompass: true,
                includeYourTrip: true,
                check01: false,
                check02: false,
                check03: false,
                check04: false,
                check05: false,
                check06: false,
                check07: false,
                check08: false,
                check09: false,
                check10: false,
                check11: false,
                check12: false,
                check13: false,
                check14: false,
                check15: false,
                check16: false,
                check17: false,
                check18: false,
                check19: false,
                check20: false,
                company: null,
                documentId: '',
            }
        },
        async mounted() {
            if (this.editing) {
                const c = await user.getCompany(this.doc.OrgNr);

                if (c) {
                    this.company = {
                        value: c.OrgNr,
                        label: c.Name,
                        Branch: c.Bransch,
                        BranchText: c.BranschText,
                        dateTo: c.DateTo,
                        SieAggVersion: this.doc.SieAggVersion,
                    };
                }

                this.selected = this.doc.CommentType;
                this.comment = this.doc.Comment;
                this.includeYourTrip = this.doc.IncludeYourTrip;
                this.inlcudeCompass = this.doc.IncludeCompass;

                for (let i=0; i<5; i++) {
                    var no = (i+1).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false});
                    if (this.doc.notes[i]) {
                        this['text'+no] = this.doc.notes[i].text;
                        this['check'+no] = this.doc.notes[i].marked;
                    }
                }
                for (let i=0; i<5; i++) {
                    var no = (i+6).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false});
                    if (this.doc.future[i]) {
                        this['text'+no] = this.doc.future[i].text;
                        this['check'+no] = this.doc.future[i].marked;
                    }
                }
                for (let i=0; i<5; i++) {
                    var no = (i+11).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false});
                    if (this.doc.misc[i]) {
                        this['text'+no] = this.doc.misc[i].text;
                        this['check'+no] = this.doc.misc[i].marked;
                    }
                }
                for (let i=0; i<5; i++) {
                    var no = (i+16).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false});
                    if (this.doc.covid[i]) {
                        this['text'+no] = this.doc.covid[i].text;
                        this['check'+no] = this.doc.covid[i].marked;
                    }
                }
            }
        },
        watch: {
            async selectedSource() {
                if (!this.selectedSource) {
                    this.comment = '';
                    return;
                }

                if (this.selectedSource.id === 0) {
                    this.ranking = await api.getRanking(user.version, this.selectedCompany.value);
                } else {
                    this.ranking = await api.getRankingSie(this.selectedSource.id, this.selectedCompany.value);
                }
                if (this.selected === 'auto') {
                    this.comment = this.ranking.sheets[0].comment;
                }
            },
        },
        methods: {
            selectedChanged(value) {
                if (value === 'no') {
                    this.comment = '';
                } else {
                    this.comment = this.ranking.sheets[0].comment;
                }
            },
            canCreate() {
                return this.selectedCompany && this.selectedSource && this.selectedSource.id > 0 && this.selectedBranch;
            },
            async create() {
                if (!this.canCreate()) return;

                let notes = [];
                let future = [];
                let misc = [];
                let covid = [];
                const text = [this.text01,this.text02,this.text03,this.text04,this.text05,this.text06,this.text07,this.text08,this.text09,this.text10,this.text11,this.text12,this.text13,this.text14,this.text15,this.text16,this.text17,this.text18,this.text19,this.text20];
                const check = [this.check01,this.check02,this.check03,this.check04,this.check05,this.check06,this.check07,this.check08,this.check09,this.check10,this.check11,this.check12,this.check13,this.check14,this.check15,this.check16,this.check17,this.check18,this.check19,this.check20];
                for (let i=0; i<5; i++) {
                    if (text[i] !== '') {
                        notes.push({text: text[i], marked: check[i]})
                    }
                }
                for (let i=5; i<10; i++) {
                    if (text[i] !== '') {
                        future.push({text: text[i], marked: check[i]})
                    }
                }
                for (let i=10; i<15; i++) {
                    if (text[i] !== '') {
                        misc.push({text: text[i], marked: check[i]})
                    }
                }
                for (let i=15; i<20; i++) {
                    if (text[i] !== '') {
                        covid.push({text: text[i], marked: check[i]})
                    }
                }

                let OrgNr = this.selectedCompany.value;
                const doc = {
                    Type: 'yearendmeeting',
                    OrgNr: OrgNr,
                    BasedOn: this.selectedSource.source,
                    SieAggVersion: this.selectedSource.id,
                    Bransch: this.selectedBranch.id,
                    BranschText: this.selectedBranch.text,
                    CommentType: this.selected,
                    Comment: this.selected === 'auto' ? '' : this.comment,
                    IncludeCompass: this.inlcudeCompass,
                    IncludeYourTrip: this.includeYourTrip,
                    notes: notes,
                    future: future,
                    covid: covid,
                    misc: misc,
                    DocumentId: this.editing ? this.doc.DocumentId : '',
                };
                if (this.editing) {
                    await api.updateDocument(doc);
                    await user.getUser('Uppdaterar dokument');
                } else {
                    await api.addDocument(doc);
                    await user.getUser('Skapar dokument');
                }
                this.$router.push({ name: 'documents', params: { OrgNr } });
            },
        },
        computed: {
            editing() {
                return this.$router.currentRoute.name === 'editdocument';
            },
        }
    }
</script>

<style scoped>
    .title {
        font-size: 1.5rem;
        font-weight: 600;
    }
    .name {
        font-size: 0.875rem;
        color: gray;
        text-transform: uppercase;
        font-weight: 400;
    }
    .value {
        font-size: 1.25rem;
        font-weight: 400;
    }
    .heading {
        font-size: 1.5rem;
        font-weight: 300;
        color: black;
    }

    .star {
        margin-top: 12px;
    }

    ::placeholder {
        font-size: 1.25rem;
        font-weight: 300;
        font-style: italic;
        color: darkgray;
    }

    .collapsed > .when-opened,
    :not(.collapsed) > .when-closed {
        display: none;
    }
</style>
